import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { EMlpIconTypes, EMplVariantTypes, MplIconMessage } from '@mopla/ui';

export const EmptyState = () => {
	const { t } = useTranslation('ticketshop');

	return (
		<Box data-testid="ticketshop-empty-state">
			<MplIconMessage
				type={EMlpIconTypes.Information}
				variant={EMplVariantTypes.Info}
				message={t('empty_state')}
			/>
		</Box>
	);
};
